<template>
  <div class="not-found-container">
    <div class="not-found-circle">
      <span class="not-found-code">404</span>
    </div>
    <h1 class="not-found-title">Página no encontrada</h1>
    <p class="not-found-subtitle">
      La ruta que buscás no existe o fue movida. Verificá la URL o volvé al inicio.
    </p>
    <router-link to="/" class="not-found-button">
      Volver al inicio
    </router-link>
  </div>
</template>

<script setup lang="ts">
// 404 Not Found page
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--oa-bg-2);
  text-align: center;
  padding: 16px;
}

.not-found-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(46, 127, 181, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.not-found-code {
  font-size: 2rem;
  font-weight: 700;
  color: var(--oa-gold-full);
  font-family: var(--oa-font-display);
}

.not-found-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--oa-text-primary);
  margin: 0 0 8px 0;
}

.not-found-subtitle {
  font-size: 0.875rem;
  color: var(--oa-text-secondary);
  margin: 0 0 32px 0;
  max-width: 400px;
  line-height: 1.5;
}

.not-found-button {
  display: inline-block;
  padding: 12px 24px;
  background: var(--oa-gold-full);
  color: var(--color-white-cap);
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: var(--oa-radius-lg);
  text-decoration: none;
  transition: background var(--oa-duration-normal) var(--oa-ease);
}

.not-found-button:hover {
  background: var(--oa-gold-bright);
}
</style>
